import { memo } from 'react';

interface GlowAnimationProps {
  /** Base stdDeviation value (default: 8) */
  baseValue?: number;
  /** Minimum stdDeviation multiplier (default: 0.7) */
  minMultiplier?: number;
  /** Maximum stdDeviation multiplier (default: 1.2) */
  maxMultiplier?: number;
  /** Animation duration in seconds (default: 4) */
  duration?: number;
}

function GlowAnimation({
  baseValue = 8,
  minMultiplier = 0.8,
  maxMultiplier = 1.2,
  duration = 4,
}: GlowAnimationProps) {
  const minValue = baseValue * minMultiplier;
  const maxValue = baseValue * maxMultiplier;

  return (
    <animate
      attributeName="stdDeviation"
      values={`${baseValue}; ${maxValue}; ${baseValue}; ${minValue}; ${baseValue}`}
      dur={`${duration}s`}
      repeatCount="indefinite"
      calcMode="spline"
      keySplines="0.45 0 0.55 1; 0.45 0 0.55 1; 0.45 0 0.55 1; 0.45 0 0.55 1"
    />
  );
}

export default memo(GlowAnimation);
